import React from 'react';
import PropTypes from 'prop-types';

export default function IconStarBlack({ className = '' }) {
    return (
        <svg
            className={className}
            width="12"
            height="11"
            viewBox="0 0 12 11"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            role="img"
            aria-hidden="true"
        >
            <path
                id="Star1"
                d="M6 0L7.58702 3.81565L11.7063 4.1459L8.56785 6.83435L9.52671 10.8541L6 8.7L2.47329 10.8541L3.43215 6.83435L0.293661 4.1459L4.41298 3.81565L6 0Z"
                fill="black"
            />
        </svg>
    );
}

IconStarBlack.propTypes = {
    className: PropTypes.string
};
